window.addEventListener('alpine:init', bootstrap);

export default (
	speed = 1,
	space_x = 0,
	dynamic_width_elements = false
) => ({
	original_element: null,
	isIPhone: false,
	init() {
		this.isIPhone = /iPhone|iPod/.test(navigator.platform);
		if ( this.isIPhone ) {
			this.$root.classList.add('is-iphone');
		}
		if ( dynamic_width_elements ) {
			// TODO build out support
		}
		// Store the original element so we can restore it on screen resize later
		this.original_element = this.$el.cloneNode(true);
		const original_width = this.$el.scrollWidth + space_x * 4;

		// Required for the marquee scroll animation to loop smoothly
		// without jumping
		this.$el.style.setProperty('--marquee-width', original_width + 'px');
		this.$el.style.setProperty(
			'--marquee-time',
			((1 / speed) * original_width) / 100 + 's'
		);
		this.resize();
	},
	resize() {
		// Reset to original elements
		this.$el.innerHTML = this.original_element.innerHTML;

		if ( this.isIPhone ) {
			return;
		}

		// Keep cloning till overflow
		let i = 0;
		while ( this.$el.scrollWidth <= this.$el.clientWidth ) {
			if ( dynamic_width_elements ) {
				// TODO implement
			} else {
				this.$el.appendChild(
					this.original_element.children[i].cloneNode(true)
				);
			}
			i += 1;
			i = i % this.original_element.childElementCount;
		}

		// Add another "original element count" of clones so the animation
		// has enough elements off-screen to scroll into view
		let j = 0;
		while ( j < this.original_element.childElementCount ) {
			this.$el.appendChild(
				this.original_element.children[i].cloneNode(true)
			);
			j += 1;
			i += 1;
			i = i % this.original_element.childElementCount;
		}
	}
});

function bootstrap() {
	document.querySelectorAll('.js-marquee').forEach(
		$$ => bootstrapMarquee($$)
	);
}

function bootstrapMarquee($el) {
	$el.setAttribute('x-data', 'marquee');
	$el.setAttribute('x-on:resize.window.debounce.100ms', 'resize');
}
